// extracted by mini-css-extract-plugin
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--LxNAe";
export var fontsLoading = "breadcrumbs-module--fonts-loading--YPfnM";
export var h4 = "breadcrumbs-module--h4--M53jY";